import { render, staticRenderFns } from "./InvestorInfo.vue?vue&type=template&id=a8151aaa&"
import script from "./InvestorInfo.vue?vue&type=script&lang=js&"
export * from "./InvestorInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports